import { render, staticRenderFns } from "./lifeGuard.vue?vue&type=template&id=08af1f0a&"
import script from "./lifeGuard.vue?vue&type=script&lang=js&"
export * from "./lifeGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports